import React, {ReactElement, ReactNode, useEffect, useState} from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './index-media.scss';
import './components/App/App.scss';
import './components/App/App-media.scss';
import './components/MainBlock/MainBlock.scss';
import './components/MainBlock/MainBlock-media.scss';
import './components/LinkBig/LinkBig.scss';
import './components/LinkBig/LinkBig-media.scss';
import './components/DescriptionBlock/DescriptionBlock.scss';
import './components/DescriptionBlock/DescriptionBlock-media.scss';
import './components/CardPhoto/CardPhoto.scss';
import './components/CardPhoto/CardPhoto-media.scss';
import App from './components/App/App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import {Provider} from 'react-redux';
import {ProjectProvider} from './redux/contexts/ProjectProvider';
import {ServiceData} from './redux/services/ServiceRedux';
import service from './redux/store';
import {BrowserRouter as Router} from 'react-router-dom';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cube';
import Header from "./components/Header/Header/Header";

import './native.ts';
import PageVacancy from "./pages/PageVacancy/PageVacancy";
import SliderMainBlock from "./components/SliderMainBlock/SliderMainBlock";
import MainBlockForm from "./components/MainBlock/MainBlockForm";
import BlockCarousel from "./components/BlockCarousel/BlockCarousel";
import SliderLogos from "./components/SliderLogos/SliderLogos";
import TermsDelivery from "./components/TermsDelivery/TermsDelivery";
import FormContacts from "./components/FormContacts/FormContacts";
import SliderReviews from "./components/SliderReviews/SliderReviews";
import FormContactsNew from "./components/FormContactsNew/FormContactsNew";
import FormContactsExtended from "./components/FormContactsExtended/FormContactsExtended";
import FormVacancy from "./components/FormVacancy/FormVacancy";
import FormVacancies from "./components/FormVacancies/FormVacancies";
import FormVacancyCustom from "./components/FormVacancyCustom/FormVacancyCustom";
import FormMiniHorizontal from "./components/FormMiniHorizontal/FormMiniHorizontal";
import FormDelivery from "./components/FormDelivery/FormDelivery";
import MkHeroForm from "./components/MkHeroForm/MkHeroForm";
import ModalFormTrigger from "./components/ModalFormTrigger/ModalFormTrigger";
import MkFormBridge from "./components/MkFormBridge/MkFormBridge";
import YoutubeBlock from "./components/YoutubeBlock/YoutubeBlock";
import {MapBlock} from "./pages/PageContacts/PageContacts";
import {ContactsEkb, ContactsKazan, ContactsMsk, ContactsNn, ContactsSpb} from "./pages/PageContacts/constants";
import PageTracking from "./pages/PageTracking/PageTracking";
import BlockCalculator from "./components/BlockCalculator/BlockCalculator";
import SliderGallery from "./components/SliderGallery/SliderGallery";
import PageLive from "./pages/PageLive/PageLive";
import PageVacancies from "./pages/PageVacancies/PageVacancies";
import Cookies from "./components/Cookies/Cookies";


declare global {
  interface Window {
    dataLayer: any[];
  }
}
window.dataLayer = window.dataLayer || [];

const WrapComponent = (component: ReactElement) => (
  <React.StrictMode>
    <Provider store={service}>
      <ErrorBoundary>
        <ProjectProvider value={ServiceData}>
          <Router>
            {component}
          </Router>
        </ProjectProvider>
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
)

const vacancyContainer = document.getElementById('vacancy-root') as HTMLElement;
if (vacancyContainer) {
  const vacancyRoot = ReactDOM.createRoot(vacancyContainer);
  const vacancyTitle = vacancyContainer.dataset.title;
  vacancyRoot.render(WrapComponent(<PageVacancy vacancyTitle={vacancyTitle}/>));
}

const Application = () => <App/>;

const rootElement = document.getElementById('root') as HTMLElement;
if (rootElement) {
  const contentRoot = ReactDOM.createRoot(rootElement);
  if (contentRoot) {
    contentRoot.render(WrapComponent(<Application/>));
  } else {
  }
}

const attachComponentBySelector = (cssSelector: string, callback: (props: any) => React.JSX.Element) => {
  console.log('attachComponentBySelector', cssSelector);
  const elements = document.querySelectorAll(cssSelector);
  for (let i = 0; i < elements.length; i++) {
    try {
      const element = elements[i];
      let dataProps = element.getAttribute('data-props');
      if (dataProps === 'inner') {
        dataProps = element.innerHTML.trim();
      }
      let props: any = {};
      if (dataProps) {
        props = JSON.parse(dataProps);
      }
      props.parentNode = element;
      console.log('rendering', cssSelector, 'with props', props);
      const root = ReactDOM.createRoot(element);
      const component = callback(props);
      root.render(component);
      element.removeAttribute('style');
    } catch (e) {
      console.error('cannot render', cssSelector, e);
    }
  }
}

attachComponentBySelector('.react-header', (props) => WrapComponent(<Header {...props} menu={props.menu}/>));

attachComponentBySelector('.react-blog-slider', (props) => <SliderMainBlock {...props}/>);
attachComponentBySelector('.react-main-block-form', (props) => WrapComponent(<MainBlockForm {...props}/>));
attachComponentBySelector('.react-company-logos', (props) => WrapComponent(<SliderLogos title={props.title}
                                                                                        slidesLogo={props.items}
                                                                                        parentNode={props.parentNode}/>));
attachComponentBySelector('.react-terms-delivery', (props) => WrapComponent(<TermsDelivery/>));
attachComponentBySelector('.react-advantage-slider', (props) => WrapComponent(<BlockCarousel {...props}/>));
attachComponentBySelector('.react-form-contacts', (props) => WrapComponent(<FormContacts {...props}/>));
attachComponentBySelector('.react-slider-reviews', (props) => <SliderReviews {...props}/>);
attachComponentBySelector('.react-form-contacts-new', (props) => WrapComponent(<FormContactsNew {...props}/>));
attachComponentBySelector('.react-form-contacts-extended', (props) => WrapComponent(
  <FormContactsExtended {...props}/>));
attachComponentBySelector('.react-form-vacancy', (props) => WrapComponent(<FormVacancy {...props}/>));
attachComponentBySelector('.react-form-vacancies', (props) => WrapComponent(<FormVacancies {...props}/>));
attachComponentBySelector('.react-form-vacancy-custom', (props) => WrapComponent(<FormVacancyCustom {...props}/>));
attachComponentBySelector('.react-form-mini-horizontal', (props) => WrapComponent(<FormMiniHorizontal {...props}/>));
attachComponentBySelector('.react-form-delivery', (props) => WrapComponent(<FormDelivery {...props}/>));
attachComponentBySelector('.react-mk-hero-form', (props) => WrapComponent(<MkHeroForm {...props}/>));
attachComponentBySelector('.react-modal-form-trigger', (props) => WrapComponent(<ModalFormTrigger {...props}/>));
attachComponentBySelector('.react-mk-form-bridge', (props) => WrapComponent(<MkFormBridge {...props}/>));
attachComponentBySelector('.react-youtube', (props) => WrapComponent(<YoutubeBlock {...props}/>));
const DelayedMount = ({delay, children}: {delay: number; children: React.ReactNode}) => {
  const [show, setShow] = useState(delay === 0);
  useEffect(() => {
    if (delay === 0) return;
    const t = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(t);
  }, [delay]);
  return show ? <>{children}</> : null;
};

attachComponentBySelector('.react-map-msk', (props) => <MapBlock contacts={ContactsMsk}
                                                                 widthWindow={1280} {...props}/>);
attachComponentBySelector('.react-map-spb', (props) => <DelayedMount delay={700}><MapBlock contacts={ContactsSpb}
                                                                                            widthWindow={1280} {...props}/></DelayedMount>);
attachComponentBySelector('.react-map-nn', (props) => <DelayedMount delay={1400}><MapBlock contacts={ContactsNn}
                                                                                            widthWindow={1280} {...props}/></DelayedMount>);
attachComponentBySelector('.react-map-kazan', (props) => <DelayedMount delay={2100}><MapBlock contacts={ContactsKazan}
                                                                                               widthWindow={1280} {...props}/></DelayedMount>);
attachComponentBySelector('.react-map-ekb', (props) => <DelayedMount delay={2800}><MapBlock contacts={ContactsEkb}
                                                                                             widthWindow={1280} {...props}/></DelayedMount>);
attachComponentBySelector('.react-tracking-page', (props) => WrapComponent(<PageTracking {...props}/>));
attachComponentBySelector('.react-calculator', (props) => WrapComponent(<BlockCalculator {...props}/>));
attachComponentBySelector('.react-gallery', (props) => <SliderGallery {...props}/>);
attachComponentBySelector('.react-blog', (props) => WrapComponent(<PageLive {...props}/>));
attachComponentBySelector('.react-vacancies', (props) => WrapComponent(<PageVacancies {...props}/>));

attachComponentBySelector('#cookies', (props) => WrapComponent(<Cookies/>));
